import { useMemo, useState } from 'react';
import { PlayerRef } from '@remotion/player';
import {
  getGroupedSoundEffects,
  getSortedCategories,
  SoundEffectCategory,
} from '@/features/remotion-editor/scripts/sound-effect-data';
import SoundEffectCategorySection from './SoundEffectCategory';

interface SoundEffectContentProps {
  playerRef: React.RefObject<PlayerRef | null>;
}

export default function SoundEffectContent({
  playerRef,
}: SoundEffectContentProps) {
  // 기본적으로 모든 카테고리 펼침
  const [expandedCategories, setExpandedCategories] = useState<
    Set<SoundEffectCategory>
  >(new Set(['ui', 'transition', 'pop', 'action']));

  const groupedSoundEffects = useMemo(() => getGroupedSoundEffects(), []);
  const sortedCategories = useMemo(() => getSortedCategories(), []);

  const toggleCategory = (category: SoundEffectCategory) => {
    setExpandedCategories((prev) => {
      const next = new Set(prev);
      if (next.has(category)) {
        next.delete(category);
      } else {
        next.add(category);
      }
      return next;
    });
  };

  return (
    <div className="flex h-full w-full flex-col overflow-y-auto px-2xs py-sm layout-padding-bottom">
      <div className="flex flex-col gap-2xs">
        {sortedCategories.map((category) => {
          const items = groupedSoundEffects.get(category);
          // 해당 카테고리에 아이템이 없으면 렌더링하지 않음
          if (!items || items.length === 0) return null;

          return (
            <SoundEffectCategorySection
              key={category}
              category={category}
              items={items}
              isExpanded={expandedCategories.has(category)}
              onToggle={() => toggleCategory(category)}
              playerRef={playerRef}
            />
          );
        })}
      </div>
    </div>
  );
}
